// extracted by mini-css-extract-plugin
module.exports = {"languageSection":"Language_languageSection_2nbCY"};